export const handleKeyPressLettersAndNumbers = (e: React.KeyboardEvent) => {
  if (!e.key.match(/^[a-zA-Z0-9_.-]*$/) && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
    e.preventDefault();
  }
};

export const formatDate = (date: string) => {
  const parts = date.split('/');
  const day = parts[0];
  const month = parts[1];
  const year = parts[2];
  const newFormat = `${year}-${month}-${day}`;
  return newFormat;
};
